(function() {
  'use strict';

  var SKU_TO_HANDLE = {
    'TAS-604': 'tas-604',
    'TAS-607': 'tas-609-multi-red-rustic-brick-effect-copy',
    'TAS-608': 'tas-608',
    'TAS-609': 'tas-609',
    'TAS-611': 'tas-611',
    'TAS-706': 'tas-706',
    'TAS-707': 'tas-707',
    'TAS-712': 'tas-607-rustic-sandstone-brick-effect-copy-3',
    'TAS-713': 'tas-713',
    'KESTAS-106': 'kestas-106',
    'KESTAS-107': 'tas-607-rustic-sandstone-brick-effect-copy-6'
  };

  var SKU_RE = /\b(TAS-\d{3,4}|KESTAS-\d{3,4}|OYTAS-\d{3,4}|DOKTAS-\d{3,4}|BUZTAS-\d{3,4}|TUGLA-\d{3,4}|KARMA-\d{3,4})\b/;
  var SKU_RE_G = new RegExp(SKU_RE.source, 'g');

  function skuUrl(sku) {
    if (SKU_TO_HANDLE[sku]) return '/products/' + SKU_TO_HANDLE[sku];
    return '/search?q=' + encodeURIComponent(sku);
  }

  function getRoot() {
    return document.querySelector('[data-template="page.gallery"]') || document.querySelector('main');
  }

  function hideBestsellerCaptions() {
    var root = getRoot();
    if (!root) return;
    var all = root.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div');
    all.forEach(function(el) {
      if (el.closest('.kb-peek-carousel')) return;
      var childCount = el.children.length;
      if (childCount > 1) return;
      var txt = (el.textContent || '').trim();
      if (txt === 'Bestseller' || txt.toLowerCase() === 'bestseller') {
        el.style.display = 'none';
        var wrap = el.closest('[class*="caption"]') || el.parentElement;
        if (wrap && wrap !== root) wrap.style.display = 'none';
      }
    });
  }

  function linkifySkus() {
    var root = getRoot();
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (!node.textContent || !node.textContent.trim()) return NodeFilter.FILTER_REJECT;
        var p = node.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        if (p.closest('a')) return NodeFilter.FILTER_REJECT;
        if (p.closest('script,style,.kb-peek-carousel')) return NodeFilter.FILTER_REJECT;
        return SKU_RE.test(node.textContent) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var found = [];
    var n;
    while ((n = walker.nextNode())) found.push(n);
    found.forEach(function(node) {
      var text = node.textContent;
      var parts = text.split(SKU_RE_G);
      if (parts.length < 3) return;
      var frag = document.createDocumentFragment();
      for (var i = 0; i < parts.length; i++) {
        if (i % 2 === 0) {
          if (parts[i]) frag.appendChild(document.createTextNode(parts[i]));
        } else {
          var sku = parts[i];
          var a = document.createElement('a');
          a.href = skuUrl(sku);
          a.className = 'kb-sku-link';
          a.textContent = 'Shop ' + sku + ' →';
          frag.appendChild(a);
        }
      }
      node.parentNode.replaceChild(frag, node);
    });
  }

  function hideShopNowButtons() {
    var root = getRoot();
    if (!root) return;
    var links = root.querySelectorAll('a, button');
    links.forEach(function(el) {
      if (el.closest('.kb-peek-carousel')) return;
      var txt = (el.textContent || '').trim().toLowerCase();
      if (txt === 'shop now' || txt === 'shop now →' || txt === 'shop now→') {
        el.classList.add('kb-hide-shop-now');
      }
    });
  }

  function forceCreamTitleBackground() {
    var root = getRoot();
    if (!root) return;
    root.style.background = '#f7f2e9';
    var mainPageEls = root.querySelectorAll('[class*="main-page"], .main-page, .section-background');
    mainPageEls.forEach(function(el) {
      el.style.background = '#f7f2e9';
      el.style.backgroundColor = '#f7f2e9';
    });
  }

  function buildPeekCarousel() {
    var root = getRoot();
    if (!root) return;
    var candidates = root.querySelectorAll('section, [class*="slideshow"], slideshow-component, [id*="slideshow"], .slideshow-container');
    var slideshow = null;
    for (var i = 0; i < candidates.length; i++) {
      var imgs = candidates[i].querySelectorAll('img');
      if (imgs.length >= 8) {
        slideshow = candidates[i];
        break;
      }
    }
    if (!slideshow) return;

    var srcs = [];
    var seen = {};
    slideshow.querySelectorAll('img').forEach(function(img) {
      var src = img.currentSrc || img.src || img.dataset.src;
      if (!src && img.srcset) src = img.srcset.split(',')[0].trim().split(' ')[0];
      if (src && !seen[src]) {
        seen[src] = true;
        srcs.push(src);
      }
    });
    if (srcs.length < 3) return;

    var carousel = document.createElement('div');
    carousel.className = 'kb-peek-carousel';
    var slidesHtml = srcs.map(function(src) {
      return '<div class="kb-peek-carousel__slide"><img src="' + src + '" alt="Customer photo" loading="lazy"></div>';
    }).join('');
    carousel.innerHTML = ''
      + '<div class="kb-peek-carousel__heading">More customer photos</div>'
      + '<button class="kb-peek-carousel__button kb-peek-carousel__button--prev" aria-label="Previous photo">'
      +   '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>'
      + '</button>'
      + '<div class="kb-peek-carousel__track" role="region" aria-label="Customer photos">' + slidesHtml + '</div>'
      + '<button class="kb-peek-carousel__button kb-peek-carousel__button--next" aria-label="Next photo">'
      +   '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>'
      + '</button>';

    slideshow.style.display = 'none';
    slideshow.parentNode.insertBefore(carousel, slideshow);

    var track = carousel.querySelector('.kb-peek-carousel__track');
    var slides = track.querySelectorAll('.kb-peek-carousel__slide');
    var prev = carousel.querySelector('.kb-peek-carousel__button--prev');
    var next = carousel.querySelector('.kb-peek-carousel__button--next');

    function updateActive() {
      var rect = track.getBoundingClientRect();
      var centerX = rect.left + rect.width / 2;
      var closest = null;
      var closestDist = Infinity;
      slides.forEach(function(slide) {
        var r = slide.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - centerX);
        if (d < closestDist) { closestDist = d; closest = slide; }
      });
      slides.forEach(function(s) { s.classList.toggle('is-active', s === closest); });
    }

    function move(dir) {
      var active = track.querySelector('.kb-peek-carousel__slide.is-active') || slides[0];
      var target = dir === 'next' ? active.nextElementSibling : active.previousElementSibling;
      if (target && target.classList.contains('kb-peek-carousel__slide')) {
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    prev.addEventListener('click', function() { move('prev'); });
    next.addEventListener('click', function() { move('next'); });
    slides.forEach(function(s) {
      s.addEventListener('click', function() {
        if (!s.classList.contains('is-active')) {
          s.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    var scrollTimer;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActive, 80);
    });

    document.addEventListener('keydown', function(e) {
      if (!document.querySelector('.kb-peek-carousel')) return;
      if (e.key === 'ArrowRight') move('next');
      if (e.key === 'ArrowLeft') move('prev');
    });

    var mid = Math.floor(slides.length / 2);
    setTimeout(function() {
      slides[mid].scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
      setTimeout(updateActive, 100);
    }, 100);
  }

  function init() {
    forceCreamTitleBackground();
    hideBestsellerCaptions();
    linkifySkus();
    hideShopNowButtons();
    buildPeekCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();